export { default as NProgress, progressProps } from './src/Progress';
